export * from './marksstu/marksstu.component';
export * from './markssub/markssub.component';
export * from './labvisit/labvisit.component';
export * from './assignment/assignment.component';
export * from './worksheet/worksheet.component';
export * from './eventgallary/eventgallary.component';